"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        _super.apply(this, arguments);
    }
    default_1.prototype.render = function () {
        var _a = this.props, generateRandomBoard = _a.generateRandomBoard, togglePlay = _a.togglePlay, isPlaying = _a.isPlaying;
        return (React.createElement("div", {className: "controls"}, 
            React.createElement("img", {className: "controls__icon", src: "imgs/reload.svg", alt: "reload", onClick: generateRandomBoard}), 
            React.createElement("img", {className: "controls__icon", src: "imgs/" + (isPlaying ? 'pause' : 'play') + ".svg", alt: "play", onClick: togglePlay}), 
            React.createElement("a", {href: "http://mathworld.wolfram.com/CellularAutomaton.html", target: "help"}, 
                React.createElement("img", {className: "controls__icon", src: "imgs/lamp.svg", alt: "help"})
            )));
    };
    return default_1;
}(React.PureComponent));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/controls.tsx
 ** module id = 11
 ** module chunks = 0
 **/